import { apiClient } from '../../../shared/lib/apiClient';

// The API and the frontend dev server run on different origins/ports
// locally (no Vite dev proxy configured) -- a plain "/api/v1/..." path used
// directly as an <img src> or CSS background-image resolves against the
// FRONTEND's own origin instead, which has no such route (Vite's dev
// server falls back to serving index.html for it, so the "image" silently
// becomes an HTML page). Every branding asset URL rendered directly by the
// browser must go through this to get the right origin.
function apiBaseUrl() {
  return (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');
}

export function publicLogoUrl(tenantSlug) {
  return `${apiBaseUrl()}/api/v1/public/branding/logo?tenant=${encodeURIComponent(tenantSlug)}`;
}

export function publicBackgroundImageUrl(tenantSlug, imageId) {
  return `${apiBaseUrl()}/api/v1/public/branding/background-images/${imageId}?tenant=${encodeURIComponent(tenantSlug)}`;
}

export function getBrandingSettings() {
  return apiClient.get('/branding');
}

export function updateBrandingSettings(payload) {
  return apiClient.patch('/branding', payload);
}

export function uploadLogo(formData) {
  return apiClient.upload('/branding/logo', formData);
}

export function deleteLogo() {
  return apiClient.delete('/branding/logo');
}

export function uploadBackgroundImage(formData) {
  return apiClient.upload('/branding/background-images', formData);
}

export function reorderBackgroundImages(orderedIds) {
  return apiClient.patch('/branding/background-images/reorder', { orderedIds });
}

export function deleteBackgroundImage(id) {
  return apiClient.delete(`/branding/background-images/${id}`);
}

// ---- Public (pre-login) ----------------------------------------------------
// Deliberately bypasses apiClient (no auth header/401-retry logic applies
// pre-login) and hits the public router directly with an explicit tenant
// slug -- see apps/api/src/modules/branding/public-routes.js.
export async function getPublicBranding(tenantSlug, lang) {
  const params = new URLSearchParams({ tenant: tenantSlug || '', lang: lang || '' });
  const res = await fetch(`${apiBaseUrl()}/api/v1/public/branding?${params}`);
  if (!res.ok) return null;
  const body = await res.json().catch(() => null);
  return body?.data || null;
}
